import { call, select } from 'redux-saga/effects';
import { RT } from '../../../../shared/types';
import { pageCreationFlowModel } from '../../';
import { logger } from '../../../../shared/lib';
import { collaborationApi } from '../../../../shared/api/axios/collaboration';
import { teamsModel } from '../../../../features/teams/model';
import { generateHTML } from '@tiptap/core';
import { sharedMainEditorExtensions } from '@distribute/shared/tiptap/extensions';

export function* getTabsContext(useTabsAsContext: boolean) {
  const currentTeam: RT<
    typeof teamsModel.selectors.selectCurrentTeamWithError
  > = yield select(teamsModel.selectors.selectCurrentTeamWithError);

  const data: RT<typeof pageCreationFlowModel.selectors.selectData> =
    yield select(pageCreationFlowModel.selectors.selectData);

  if (!useTabsAsContext) {
    return '';
  }

  if (!data) {
    logger.error('No page data found when getting tabs context');
    return '';
  }

  const response: RT<typeof collaborationApi.getContent> = yield call(
    collaborationApi.getContent,
    { pageId: data.pageId, teamId: currentTeam.id }
  );

  return response
    .map((el) => generateHTML(el.contentJson, sharedMainEditorExtensions))
    .join('\n');
}
